// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"Rating_wrpr__XSFqi","heading":"Rating_heading__wGV7q"};